import { Component, OnChanges, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { noop, Observable, Observer, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/core/authentication.service';
import { PackageListingSearchEnum, Panel, SearchOptions } from 'src/app/enums';
import { ResponseDTO } from 'src/app/models/response-dto';
import { CustomerFilterOption } from 'src/app/searchFilters/CustomerFilterOption';
import { InvoiceFilterOption } from 'src/app/searchFilters/invoiceFilterOption';
import { Overpackfilteroption } from 'src/app/searchFilters/overpackfilteroption';
import { PackageFilterOption } from 'src/app/searchFilters/package-filter-option';
import { ShipmentFilterOption } from 'src/app/searchFilters/shipment-filter-option';
import { CustomerService } from 'src/app/services/customer-service.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { OverpackServices } from 'src/app/services/overpack.service';
import { PackageServices } from 'src/app/services/package.service';
import { ShipmentService } from 'src/app/services/shipment.service';

export enum WarehouseSearchEnum {
  'Tracking No.' = 6,
  Package = 1,
  Customer = 3,
  Invoice = 2,
  BOL = 7
}


export enum FranchiseeSearchEnum {
  'Tracking No.' = 6,
  Package = 1,
  Customer = 3,
  BOL = 7,
  Invoice = 2,
}

export enum FranchisorSearch {
  'Tracking No.' = 6,
  Package = 1,
  Customer = 3,
  BOL = 7,
  Invoice = 2,
}

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})

export class SearchComponent implements OnInit {

  suggestions$: Observable<any[]>;
  search: string = "";
  typeaheadLoading: boolean = false;
  result: string = '';
  invoiceFilter: InvoiceFilterOption = new InvoiceFilterOption();
  packageFilter: PackageFilterOption = new PackageFilterOption();
  customerFilter: CustomerFilterOption = new CustomerFilterOption();
  overPackFilter: Overpackfilteroption = new Overpackfilteroption();
  shipmentFilter: ShipmentFilterOption = new ShipmentFilterOption();
  options: string = '';
  selectedOption: number;
  searchOptions: any
  isLoadingResults: boolean = false;
  observer;
  constructor(
    private invoiceApi: InvoiceService,
    private packageApi: PackageServices,
    private router: Router,
    private customerApi: CustomerService,
    private overpackApi: OverpackServices,
    private shipmentAPi: ShipmentService,
    private authenticationService: AuthenticationService
  ) { }


  ngOnInit(): void {
    if (this.authenticationService.currentUserValue.panel == Panel.Admin) {
      this.searchOptions = Object.keys(FranchisorSearch).filter(v => typeof FranchisorSearch[v] === 'number') as string[];
    }
    else if (this.authenticationService.currentUserValue.panel == Panel.Franchise) {
      this.searchOptions = Object.keys(FranchiseeSearchEnum).filter(v => typeof FranchiseeSearchEnum[v] === 'number') as string[];
    }
    else if (this.authenticationService.currentUserValue.panel == Panel.WareHouse) {
      this.searchOptions = Object.keys(WarehouseSearchEnum).filter(v => typeof WarehouseSearchEnum[v] === 'number') as string[];
    }

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    
    this.options = SearchOptions[SearchOptions.Package];
    this.selectedOption = SearchOptions[this.options];

    this.bindAutoComplete()
  }

  changeTypeaheadLoading(e: boolean): void {
    this.typeaheadLoading = e;
  }

  typeaheadInvoiceOnSelect(e: TypeaheadMatch): void {

    if (e.item.invoiceId > 0)
      this.router.navigate([`/invoices/detail/${e.item.invoiceId}`]);

    if (e.item.packageId > 0 && e.item.statusInt){
      if (this.authenticationService.currentUserValue.panel == Panel.Franchise){
        if (e.item.packageId > 0 && e.item.statusInt){
          this.router.navigate([`/packages/details/${e.item.packageId}`]);
        }
      }else{
        if (e.item.packageId > 0 && e.item.statusInt){
          this.router.navigate([this.packageApi.getRedirectionURL(e.item.packageId, e.item.statusInt, false, null)]);
        }
      }
    }

    

    if (e.item.customerId > 0)
      this.router.navigate(['/users/detail', e.item.customerId]);

    if (e.item.overpackId > 0)
      this.router.navigate(['/overpacks/detail', e.item.overpackId]);

    if (e.item.shipmentId > 0)
      this.router.navigate(['/consolidation-shipments/detail', e.item.shipmentId]);

  }

  onSelectOption() {
    this.selectedOption = SearchOptions[this.options];
    this.search = "";
    this.observer.next(this.search);
  }

  bindAutoComplete() {
    this.suggestions$ = new Observable((observer: Observer<string>) => {
      this.observer = observer;
      if (this.selectedOption != SearchOptions.Customer){
      this.search = this.search.toString().trim();
      }
      observer.next(this.search);
    })
      .pipe(
        switchMap((query: string = '') => {
          if (query) {
            if (this.selectedOption == SearchOptions.Invoice) {
              this.invoiceFilter.invoiceCode = query;
              this.invoiceFilter.isFromGlobalSearch = true;
              this.isLoadingResults = true;
              return query.length < 2 ? [] : this.invoiceApi.getInvoices(1, 10, 'asc', 'invoiceReferenceNumber', this.invoiceFilter)
                .pipe(
                  map((data: ResponseDTO) => {
                    this.isLoadingResults = false;
                    if (data && data["result"])
                      return data["result"]["values"];
                    else return [];
                  }),
                  tap(() => noop, err => {
                    alert(err && err.message || 'invoice not found.');
                  })
                );
            }
            if (this.selectedOption == SearchOptions.BOL) {
              this.invoiceFilter.bolNumber = query;
              this.isLoadingResults = true;
              this.invoiceFilter.isFromGlobalSearch = true;
              return query.length < 2 ? [] : this.invoiceApi.getInvoices(1, 10, 'asc', 'Bolnumber', this.invoiceFilter)
                .pipe(
                  map((data: ResponseDTO) => {
                    this.isLoadingResults = false;
                    if (data && data["result"])
                      return data["result"]["values"];
                    else return [];
                  }),
                  tap(() => noop, err => {
                    alert(err && err.message || 'invoice not found.');
                  })
                );
            }

            if (this.selectedOption == SearchOptions.Package) {
              this.packageFilter.PackageCode = query;
              this.packageFilter.isFromGlobalSearch = true;
              this.isLoadingResults = true;
              return query.length < 2 ? [] : this.packageApi.getSearchPackages(1, 10, 'asc', 'packageCode', this.packageFilter)
                .pipe(
                  map((data: ResponseDTO) => {
                    this.isLoadingResults = false;
                    if (data && data["result"])
                      return data["result"]["values"];
                    else return [];
                  }),
                  tap(() => noop, err => {
                    alert(err && err.message || 'package not found.');
                  })
                );
            }

            if (this.selectedOption == SearchOptions['Tracking No.']) {
              this.packageFilter.searchKey = query;
              this.isLoadingResults = true;
              this.packageFilter.isFromGlobalSearch = true;
              return query.length < 2 ? [] : this.packageApi.getSearchPackages(1, 10, 'asc', 'trackingNumber', this.packageFilter)
                .pipe(
                  map((data: ResponseDTO) => {
                    this.isLoadingResults = false;

                    if (data && data["result"])
                      return data["result"]["values"];
                    else return [];
                  }),
                  tap(() => noop, err => {
                    alert(err && err.message || 'package not found.');
                  })
                );
            }

            if (this.selectedOption == SearchOptions.Customer) {
              this.customerFilter.searchKey = query;
              this.isLoadingResults = true;
              return query.length < 2 ? [] : this.customerApi.customersGlobalSearch(1, 10, 'asc', 'customerCode', this.customerFilter)
                .pipe(
                  map((data: ResponseDTO) => {
                    this.isLoadingResults = false;
                    if (data && data["result"])
                      return data["result"]["values"];
                    else return [];
                  }),
                  tap(() => noop, err => {
                    alert(err && err.message || 'customer not found.');
                  })
                );
            }
            // if (this.selectedOption == SearchOptions.Overpack) {
            //   this.overPackFilter.searchKey = query;
            //   this.isLoadingResults = true;
            //   return query.length < 2 ? [] : this.overpackApi.getOverpacks(1, 10, 'asc', 'overpackCode', this.overPackFilter)
            //     .pipe(
            //       map((data: ResponseDTO) => {
            //         this.isLoadingResults = false;
            //         if (data && data["result"])
            //           return data["result"]["values"];
            //         else return [];
            //       }),
            //       tap(() => noop, err => {
            //         alert(err && err.message || 'overpack not found.');
            //       })
            //     );
            // }
            // if (this.selectedOption == SearchOptions.Shipment) {
            //   this.shipmentFilter.searchKey = query;
            //   this.isLoadingResults = true;
            //   return query.length < 2 ? [] : this.shipmentAPi.getSearchShipments(1, 10, 'asc', 'shipmentCode', this.shipmentFilter)
            //     .pipe(
            //       map((data: ResponseDTO) => {
            //         this.isLoadingResults = false;
            //         if (data && data["result"])
            //           return data["result"]["values"];
            //         else return [];
            //       }),
            //       tap(() => noop, err => {
            //         alert(err && err.message || 'shipment not found.');
            //       })
            //     );
            // }
          }
          return of([]);
        })
      );
  }

  keydown(event) {    
    if (this.selectedOption == SearchOptions.Customer) {
      var input = event.target;
      var val = input.value;
      var end = input.selectionEnd;
      

      if (event.keyCode == 32 && (val[end - 1] == " " || val[end] == " ")) {
      
        event.preventDefault();
        return false;
      }
    }
  }
}
